import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";

const LOGO_URL = "/logo.png";

const Footer = () => {
  return (
    <footer className="footer-zeta" data-testid="footer">
      <div className="footer-content-zeta">
        <div className="footer-top-zeta">
          <div className="footer-brand-zeta">
            <img src={LOGO_URL} alt="IntentLogic" />
            <p>
              Performance marketing powered by intent. We don't guess what works—we know.
            </p>
          </div>
          
          <div className="footer-column-zeta">
            <h4>Solutions</h4>
            <ul>
              <li><Link to="/customer-acquisition">Customer Acquisition</Link></li>
              <li><Link to="/customer-activation">Predictive Marketing</Link></li>
              <li><Link to="/political-advocacy">Political Advocacy</Link></li>
            </ul>
          </div>
          
          <div className="footer-column-zeta">
            <h4>Products</h4>
            <ul>
              <li><Link to="/cdp">Data Platform</Link></li>
              <li><Link to="/omnichannel">Omnichannel</Link></li>
              <li><Link to="/analytics">Analytics</Link></li>
            </ul>
          </div>
          
          <div className="footer-column-zeta">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/blog">Blog</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom-zeta">
          <p className="footer-copyright-zeta">
            © {new Date().getFullYear()} IntentLogic. All rights reserved. | <Link to="/privacy-policy">Privacy Policy</Link> | <Link to="/terms">Terms & Conditions</Link>
          </p>
          <div className="footer-social-zeta">
            <a href="https://www.linkedin.com/company/intentlogic" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid="social-linkedin">
              <Linkedin size={18} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
